//export const DcOffLineHost = "http://173.249.57.219:8095/";
export const DcOffLineHost = "https://backforms.ussd.sn/"